import { useEffect, useState } from "react";
import { Heart } from "lucide-react";
import { api } from "@/lib/api";

export function KudosBadge({ userId }) {
  const [n, setN] = useState(0);
  useEffect(() => { if (userId) api.get("/kudos", { params: { user_id: userId } }).then((r) => setN(r.data.items.length)).catch(() => {}); }, [userId]);
  if (!n) return null;
  return <span className="inline-flex items-center gap-0.5 rounded-full bg-pink-50 text-pink-700 border border-pink-200 px-1.5 text-[10px]" title={`${n} kudos ricevuti`} data-testid="current-user-kudos"><Heart size={9} /> {n}</span>;
}
